import { last } from 'lodash/fp';
import { lookupTypeDefinitionsByExtension } from '../files/getFileType';
import { FILE_TYPES_INFO } from '../files/fileConstants';

export const isFileExtensionValidAndNotGeneric = (fileExtension: string): boolean => {
    const validExtension = lookupTypeDefinitionsByExtension(fileExtension);
    return validExtension && validExtension !== FILE_TYPES_INFO.GENERIC;
};

export const getFileName = (file: File, contentType: string): string => {
    const { name } = file;

    // detect if file has an extension
    const nameParts = name.split('.');
    const fileExtension = last(nameParts);

    // If an extension exists, and it is not 'generic data', use the name.
    if (fileExtension && isFileExtensionValidAndNotGeneric(fileExtension)) return name;

    // if no extension, use the content type to determine the extension
    const extension = contentType?.split('/')[1];
    // if no content type, use the file name as is
    return extension ? `${name}.${extension}` : name;
};
